export default "__VITE_ASSET__DQ7ud7TE__"